/* eslint-disable import/prefer-default-export */
import { KUESKI_SESSION_STORAGE_KEY } from 'Src/consts/session';

export const shouldFetch = () => Boolean(
  localStorage.getItem(KUESKI_SESSION_STORAGE_KEY),
);

export const capitalize = (name, i) => (i ? `${name[0].toUpperCase()}${name.slice(1).toLowerCase()}` : name.toLowerCase());

export const camelize = name => name.split(/[^a-zA-Z0-9]/g).map(capitalize).join('');
